const state = {
  workers: [],
  workerTalking: 0,
  workerAvailable: 0
}

const getters = {
  workers (state) {
    return state.workers
  },
  workerTalking (state) {
    return state.workerTalking
  },
  workerAvailable (state) {
    return state.workerAvailable
  }
}

const mutations = {
  SET_WORKER_DATA (state, workerData) {
    state.workers = workerData.workers
    state.workerTalking = workerData.workerTalking
    state.workerAvailable = workerData.workerAvailable
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
